import React, { createContext, ReactNode, useContext, useState } from "react"

export interface IStorageContext {
    storageWarning: boolean
    setStorageWarning: React.Dispatch<React.SetStateAction<boolean>>
    storageCritical: boolean
    setStorageCritical: React.Dispatch<React.SetStateAction<boolean>>
}

const StorageContext = createContext<IStorageContext | null>(null)

interface ISiteProviderProps {
    children: ReactNode
}

export const StorageProvider: React.FC<ISiteProviderProps> = ({ children }) => {
    const [storageWarning, setStorageWarning] = useState(false)
    const [storageCritical, setStorageCritical] = useState(false)

    return (
        <StorageContext.Provider
            value={{
                storageWarning,
                setStorageWarning,
                storageCritical,
                setStorageCritical,
            }}
        >
            {children}
        </StorageContext.Provider>
    )
}

export const useStorageContext = () => {
    const context = useContext(StorageContext)
    if (!context) {
        throw new Error("useStorageContext must be used within a StorageProvider.")
    }
    return context
}
